var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45634 10.7071C7.06582 10.3166 7.06582 9.68337 7.45634 9.29287C7.84687 8.90238 8.48003 8.90238 8.87056 9.29287L10.8706 11.2929C11.2611 11.6834 11.2611 12.3166 10.8706 12.7071L8.87056 14.7071C8.48003 15.0976 7.84687 15.0976 7.45634 14.7071C7.06582 14.3166 7.06582 13.6834 7.45634 13.2929L8.74924 12L7.45634 10.7071Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1635 13C16.7158 13 17.1635 13.4477 17.1635 14C17.1635 14.5523 16.7158 15 16.1635 15H13.1635C12.6112 15 12.1635 14.5523 12.1635 14C12.1635 13.4477 12.6112 13 13.1635 13H16.1635Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V5.99999C22 3.79086 20.2091 2 18 2H6C3.79086 2 2 3.79086 2 6V18ZM20 18C20 19.1046 19.1046 20 18 20H10.05V19.9982H7.94998V20H6C4.89543 20 4 19.1046 4 18V10.05H4.01306V7.94998H4V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V7.94998H19.9871V10.05H20V18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareCode);
export default __webpack_public_path__ + "static/media/square_code.6a5537f0b6ca91c8ecb0db7ed32e1032.svg";
export { ForwardRef as ReactComponent };